<template>
    <div class="switch" :class="className">
        <div v-if="leftIcon" class="switch__left">
            <icon
                :icon="leftIcon"
                v-bind="leftIconProps"
            ></icon>
        </div>
        <div class="switch__element">
            <v-switch
                v-model="result"
                :color="color"
                :label="label"
                :value="value"
                dense
                :hide-details="true"
                :class="className"
            ></v-switch>
        </div>
        <div v-if="rightIcon" class="switch__right">
            <icon
                :icon="rightIcon"
                v-bind="rightIconProps"
            ></icon>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Icon from '@/components/atoms/Icon'

export default {
    name: 'sp-switch',
    components: {Icon},
    props: {
        className: {
            type: String,
            required: false,
        },
        color: {
            type: String,
            required: false,
            default: null
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        leftIcon: {
            type: String,
            required: false,
            default: null
        },
        leftIconProps: {
            type: Object,
            required: false,
            default() {
                return {
                    gradient: null,
                    color: null
                }
            }
        },
        rightIcon: {
            type: String,
            required: false,
            default: null
        },
        rightIconProps: {
            type: Object,
            required: false,
            default() {
                return {
                    gradient: null,
                    color: null
                }
            }
        },
        value: {
            type: Boolean
        }
    },
    computed: {
        ...mapState('scssVariables', {
            styles: state => state
        }),
        resolveColor() {
            return this.color && this.styles.colorPrimary
        },
        result: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style scoped lang="scss">
#spillard-theme {
    .switch {
        display: flex;
        align-items: center;

        &__left, &__right {
            display: flex;
            align-items: center;
        }

        &__element {
            padding-top: 2px;
            margin-left: 8px;
            display: flex;
            align-items: center;

            ::v-deep .v-label {
                top: 0;
            }
        }
    }

    .switch--white {
        .v-input {
            color: white !important;

            .theme--light.v-label {
                color: white !important;
            }
        }
    }
}
</style>
